import PropTypes from 'prop-types';

import Box, { BoxProps as BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import useAppMediaQuery from '@classity-edtech/ui-base/dist/hooks/useMediaQuery';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';
import { AddIcon } from '@classity-edtech/ui-base/dist/components/Displays';
import { useState } from 'react';

export interface FAQsProps extends BoxProps {
  title: string;
  faqs: { question: string; answers: string[] }[];
}

export const FAQs = ({ className, ...props }: FAQsProps) => {
  const screens = useAppMediaQuery();
  const [expanded, setExpanded] = useState<number | undefined>();
  const smallScreens = screens.isMobile || screens.isTablet;

  const handleChange = (panel: number) => {
    setExpanded(p => (p === panel ? undefined : panel));
  };

  return (
    <Box className={className} sx={{}} {...props}>
      <Container>
        <Typography variant={'subtitle1'} sx={{ maxWidth: '614px', py: 2, mb: 7 }}>
          {props?.title}
        </Typography>
        <Stack sx={{ gap: 2 }}>
          {props?.faqs?.map((p, index) => (
            <Accordion
              expanded={expanded === index}
              onChange={() => handleChange(index)}
              disableGutters
              elevation={0}
              key={index}
              square
              sx={{
                borderTop:
                  index === 0
                    ? `solid 1px ${globalColours['$global-colour-interactive-secondary-default']}`
                    : '',
                borderBottom:
                  index === props?.faqs?.length - 1 &&
                  `solid 1px ${globalColours['$global-colour-interactive-secondary-default']}`,
                bgcolor: 'transparent',
                py: 2,
              }}
            >
              <AccordionSummary
                expandIcon={
                  <Box
                    sx={{
                      background:
                        expanded === index
                          ? globalColours['$global-colour-background-neutral-default']
                          : globalColours['$global-colour-interactive-secondary-default'],
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <AddIcon
                      sx={{
                        color: globalColours['$global-colour-interactive-primary-default'],
                        width: '24px',
                        height: '24px',
                        transform: expanded === index ? 'rotate(45deg)' : '',
                      }}
                    />
                  </Box>
                }
              >
                <Typography variant='body2SemiBold'>{p?.question}</Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ maxWidth: '800px' }}>
                {p?.answers?.map((answer, i) => (
                  <Typography variant='body2' sx={{ display: 'block', py: 1 }} key={i}>
                    {answer}
                  </Typography>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};

FAQs.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

FAQs.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(FAQs)(
  ({ theme }) => `
  & .blinker {
    animation: blinker 1s linear infinite;

    @keyframes blinker {
      50% {
        opacity: 0.6;
      }
    }
  }
`,
);
